<template>
  <div class="py-4">
    <b-media no-body v-for="(step, index) in steps" :key="index" class="py-3 stepper-media">
      <div
        class="line"
        :class="[index === 0 ? 'first' : '', index === steps.length - 1 ? 'last' : '']"
      ></div>
      <b-media-aside vertical-align="center" class="stepper">
        <stepper-element
          :bg-class="index <= currentStep ? 'stepper-active' : 'stepper-inactive'"
          :content="(index + 1).toString()"
        />
      </b-media-aside>

      <b-media-body class="ml-3">
        <miu-card
          :overline="trans(`miu.${step.type}.overline`)"
          :title="trans(`miu.${step.type}.title`)"
          :icon="`/images/miu/${step.type}_${index > currentStep ? 'locked' : 'unlocked'}.png`"
          :is-dark="index === currentStep"
          :is-completed="step.isCompleted"
          :is-locked="index > currentStep"
          :cta-text="trans(`miu.${step.type}.${step.isCompleted ? 'secondary_cta' : 'cta'}`)"
          @cta="handleCta(step)"
          :no-button="step.noButton"
        />
      </b-media-body>
    </b-media>
  </div>
</template>

<script>
import StepperElement from "../atoms/StepperElement";
import MiuCard from "../molecules/cards/MiuCard";
import roleMixin from "../mixins/roleMixin";
import navMixin from "../mixins/navMixin";

export default {
  name: "VerticalStepper",
  components: { StepperElement, MiuCard },
  props: {
    currentStep: Number,
    steps: Array,
  },
  methods: {
    handleCta(step) {
      if (step.isLocked) return;

      if (step.href) {
        window.open(step.href, "_blank");
      } else if (step.serviceData) {
        this.checkService(step.serviceData.id, step.serviceData.serviceType);
      } else {
        this.$router.push(this.parseMasterNav(step.nav));
      }
    },
  },
  mixins: [roleMixin, navMixin],
};
</script>

<style scoped lang="scss">
.stepper {
  &-media {
    position: relative;
  }

  &-active {
    background-color: $color-blue;
  }

  &-inactive {
    background-color: $color-dark-600;
  }
}

.line {
  position: absolute;
  z-index: -1;
  top: 0;
  left: 32px;
  border-left: 1px solid $color-dark-600;
  height: 100%;
  &.first {
    top: 50% !important;
    height: 50% !important;
  }
  &.last {
    height: 50% !important;
  }

  @media (max-width: 767px) {
    left: 20px;
  }
}
</style>
